<script lang="ts">
	import type { ButtonColor, ButtonVariant } from '$lib/components/atoms/button/types';
	import type { ClassValue } from 'svelte/elements';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import * as m from '$paraglide/messages';

	interface Props {
		numberOfFilters?: Number;
		onclick?: (event: Event) => void;
		variant?: ButtonVariant;
		color?: ButtonColor;
		classes?: ClassValue;
	}

	const {
		numberOfFilters,
		onclick,
		variant = 'filled',
		color = 'light',
		classes,
	}: Props = $props();
</script>
<Button
	icon="tune"
	size="sm"
	{variant}
	{color}
	text={m.poi_list__filters__toggle_label()}
	class={['relative filter-button', classes]}
	ariaLabel={m.poi_list__aria_label__filter_button()}
	{onclick}
>
	{#snippet badge()}

		{#if numberOfFilters}
			<span
				aria-label={numberOfFilters === 1
					? m.poi_list__aria_label__filter_button_filtered__one({ numberOfFilters })
					: m.poi_list__aria_label__filter_button_filtered__many({ numberOfFilters })}
				data-testid="filter-badge"
				class="absolute w-4.6 h-4.6 top--1 right--1 bg-error-50 font-size-2.75 color-white rounded-full border-width-1.5 border-white border-solid"
			>
				{numberOfFilters}
			</span>
		{/if}

	{/snippet}
</Button>
